__turbopack_context__.v({
  "active": "ExpandableColumnStack-module-scss-module__BvuPBa__active",
  "container": "ExpandableColumnStack-module-scss-module__BvuPBa__container",
  "controlButton": "ExpandableColumnStack-module-scss-module__BvuPBa__controlButton",
  "dot": "ExpandableColumnStack-module-scss-module__BvuPBa__dot",
  "dotActive": "ExpandableColumnStack-module-scss-module__BvuPBa__dotActive",
  "fadeIn": "ExpandableColumnStack-module-scss-module__BvuPBa__fadeIn",
  "fadeOut": "ExpandableColumnStack-module-scss-module__BvuPBa__fadeOut",
  "image": "ExpandableColumnStack-module-scss-module__BvuPBa__image",
  "inactive": "ExpandableColumnStack-module-scss-module__BvuPBa__inactive",
  "item": "ExpandableColumnStack-module-scss-module__BvuPBa__item",
  "itemOverlayButton": "ExpandableColumnStack-module-scss-module__BvuPBa__itemOverlayButton",
  "media": "ExpandableColumnStack-module-scss-module__BvuPBa__media",
  "mobileNext": "ExpandableColumnStack-module-scss-module__BvuPBa__mobileNext",
  "mobilePrev": "ExpandableColumnStack-module-scss-module__BvuPBa__mobilePrev",
  "noTransition": "ExpandableColumnStack-module-scss-module__BvuPBa__noTransition",
  "noVideo": "ExpandableColumnStack-module-scss-module__BvuPBa__noVideo",
  "order1": "ExpandableColumnStack-module-scss-module__BvuPBa__order1",
  "order2": "ExpandableColumnStack-module-scss-module__BvuPBa__order2",
  "order3": "ExpandableColumnStack-module-scss-module__BvuPBa__order3",
  "overlay": "ExpandableColumnStack-module-scss-module__BvuPBa__overlay",
  "overlayVisible": "ExpandableColumnStack-module-scss-module__BvuPBa__overlayVisible",
  "pagination": "ExpandableColumnStack-module-scss-module__BvuPBa__pagination",
  "subtitle": "ExpandableColumnStack-module-scss-module__BvuPBa__subtitle",
  "title": "ExpandableColumnStack-module-scss-module__BvuPBa__title",
  "video": "ExpandableColumnStack-module-scss-module__BvuPBa__video",
  "wrapper": "ExpandableColumnStack-module-scss-module__BvuPBa__wrapper",
});
